(() => {
  const link = document.querySelector('[data-header-selection]');
  if (!link) return;
  const counter = link.querySelector('[data-cart-count]');
  if (!counter) return;
  const update = () => {
    const count = Number(counter.textContent.trim());
    if (!Number.isSafeInteger(count) || count < 0) return;
    link.hidden = count === 0;
    link.setAttribute('aria-label', 'Ma sélection, ' + count + ' article' + (count > 1 ? 's' : ''));
  };
  new MutationObserver(update).observe(counter, { childList: true, characterData: true, subtree: true });
  document.addEventListener('effervessens:cart-updated', event => {
    const count = event.detail && event.detail.item_count;
    if (Number.isSafeInteger(count) && count >= 0) counter.textContent = String(count);
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    try {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) counter.textContent = String(cart.item_count);
    } catch (_) {}
  });
  update();
})();
